import { admin } from "./admin";

export const emailTriggers = {
  label: "Trigger Email To Users",
  path: (tenantName) => `/${tenantName}/admin/emailTriggers`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: admin.name,
      path: admin.path,
      onClick: () => navigate(admin.path(tenantName)),
    },
    {
      key: 2,
      label: emailTriggers.label,
      path: emailTriggers.path,
      onClick: () => navigate(emailTriggers.path(tenantName)),
    },
  ],
};
